<template>
  <b-notification :has-icon="true" icon="check" :closable="false">
    <span v-html="$t('compCarbonFormsFoodsHelpEmissionsFactors.text')" />
  </b-notification>
</template>

<script>
export default {
  name: 'HelpEmissionsFactors'
}
</script>
